export default __webpack_public_path__ + "static/media/Mario.c0b0836b.jpg";